var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css, styled } from "../../../utils";
var Hint = styled.p(function (_a) {
    var _b = _a.theme, fontSizes = _b.fontSizes, fonts = _b.fonts, fontWeights = _b.fontWeights, colors = _b.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    color: ", ";\n  "], ["\n    font-size: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    color: ", ";\n  "])), fontSizes.normal, fonts.primary, fontWeights.medium, colors.primary);
});
export default Hint;
var templateObject_1;
//# sourceMappingURL=Hint.js.map